import { produce } from "immer";
import Actions from "../actions";

const initialState = {
    chatConversations: {},
    selectedChatConversationId:""
};


const chatConversations = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {

    case Actions.GET_CHAT_CONVERSATION_LIST: {
      draft.chatConversations = payload?.chatConversations;
      break;
    }
    
    case Actions.SELECTED_CHAT_CONVERSATION_ID: {
      draft.selectedChatConversationId = payload?.selectedChatConversationId;
    }

    default: {
      break;
    }
  }
}, initialState);

export default chatConversations;
